var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damageMobilier" }, [
    _c("div", { staticClass: "navbarCategories" }, [
      _c("img", {
        staticClass: "check-img",
        attrs: { src: require("@/assets/images/self-care/arrow-left.png") },
        on: { click: _vm.handleClickPrevPage },
      }),
      _c("p", { staticClass: "grayLightMouse headline-medium" }, [
        _vm._v(_vm._s(_vm.stateWarrantyDamageTypeLiteral)),
      ]),
    ]),
    _c("div", { staticClass: "list-predictibles" }, [
      _c("p", { staticClass: "text-small-bold gray mg mg--b-2" }, [
        _vm._v(_vm._s(_vm.$t("damageMobilier.search.predictibles"))),
      ]),
      _c(
        "ul",
        _vm._l(_vm.listPredictibles, function (item) {
          return _c(
            "li",
            {
              on: {
                click: function ($event) {
                  return _vm.handleClickPredictibles(item.components)
                },
              },
            },
            [
              _c("p", { staticClass: "text-small blueSkyDark" }, [
                _vm._v(_vm._s(item.literal)),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "container-inputs" },
        [
          _c("p", { staticClass: "text-small-bold gray" }, [
            _vm._v(_vm._s(_vm.$t("damageMobilier.search.containerInputs"))),
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputTxtValue,
                expression: "inputTxtValue",
              },
            ],
            staticClass: "mg mg--t-1 mg--b-4 mg--l",
            attrs: { id: "search_text", type: "text" },
            domProps: { value: _vm.inputTxtValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.inputTxtValue = $event.target.value
                },
                _vm.handleChangeInputTxt,
              ],
            },
          }),
          _c("svgicon", {
            attrs: {
              icon: "search-mobilier",
              height: "19",
              width: "19",
              color: "#7E8994",
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "container-lists" }, [
        _vm.listCategories && !_vm.searchIsActive
          ? _c(
              "ul",
              { staticClass: "listCategories" },
              _vm._l(_vm.listCategories.options, function (category) {
                return _c("li", [
                  _c(
                    "div",
                    {
                      attrs: { "data-id": category.id },
                      on: {
                        click: function ($event) {
                          return _vm.handleClickCategory(
                            _vm.listCategories.name,
                            category.key,
                            _vm.listCategories.id,
                            category.literal
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "searchText text-medium grayLightMouse",
                        },
                        [_vm._v(_vm._s(category.literal))]
                      ),
                      _c("svgicon", {
                        attrs: {
                          icon: "arrow_right",
                          height: "17",
                          width: "10",
                          color: "#C5CACF",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              0
            )
          : _vm.listNestedTitles.length > 0 &&
            _vm.searchIsActive &&
            _vm.searchNotFound === false
          ? _c(
              "ul",
              { staticClass: "category1-list" },
              [
                _c(
                  "p",
                  { staticClass: "mg mg--l-4 mg--b-3 text-small-bold gray" },
                  [_vm._v(_vm._s(_vm.$t("damageMobilier.search.categoryList")))]
                ),
                _vm._l(_vm.listNestedTitles, function (category) {
                  return _c("li", [
                    _c(
                      "div",
                      {
                        staticClass: "container-results first-level",
                        on: {
                          click: function ($event) {
                            _vm.handleClickCategorySearch(
                              category.cat1.name1,
                              category.cat1.value1
                            )
                            _vm.handleClickCategExtraDetails(
                              category.cat1.children,
                              category.cat1.literal
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "searchText text-medium grayLightMouse",
                          },
                          [_vm._v(_vm._s(category.cat1.literal))]
                        ),
                        _c("svgicon", {
                          attrs: {
                            icon: "arrow_right",
                            height: "17",
                            width: "10",
                            color: "#C5CACF",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "ul",
                      { staticClass: "category2-list" },
                      _vm._l(category.cat1.cat2, function (cat2) {
                        return _c("li", [
                          _c(
                            "div",
                            {
                              staticClass: "container-results second-level",
                              on: {
                                click: function ($event) {
                                  _vm.handleClickCategorySearch(
                                    cat2.name1,
                                    cat2.value1,
                                    cat2.name2,
                                    cat2.value2
                                  )
                                  _vm.handleClickCategExtraDetails(
                                    cat2.children,
                                    category.cat1.literal,
                                    cat2.literal
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "searchText text-medium grayLightMouse mg mg--l-3",
                                },
                                [_vm._v(_vm._s(cat2.literal))]
                              ),
                              _c("svgicon", {
                                attrs: {
                                  icon: "arrow_right",
                                  height: "17",
                                  width: "10",
                                  color: "#C5CACF",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "ul",
                            { staticClass: "category3-list" },
                            _vm._l(cat2.cat3, function (cat3) {
                              return _c("li", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "container-results mg mg--l-6",
                                    on: {
                                      click: function ($event) {
                                        _vm.handleClickCategorySearch(
                                          cat2.name1,
                                          cat2.value1,
                                          cat2.name2,
                                          cat2.value2,
                                          cat3.name3,
                                          cat3.value3
                                        )
                                        _vm.handleClickCategExtraDetails(
                                          cat3.children,
                                          category.cat1.literal,
                                          cat2.literal,
                                          cat3.literal
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "searchText text-medium grayLightMouse",
                                      },
                                      [_vm._v(_vm._s(cat3.literal))]
                                    ),
                                    _c("svgicon", {
                                      attrs: {
                                        icon: "arrow_right",
                                        height: "17",
                                        width: "10",
                                        color: "#C5CACF",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ])
                      }),
                      0
                    ),
                  ])
                }),
              ],
              2
            )
          : _vm.searchNotFound === true
          ? _c("div", { staticClass: "container-empty_txt" }, [
              _c("p", { staticClass: "gray text-medium" }, [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt1"))
                ),
              ]),
              _c("p", { staticClass: "headline-medium mg mg--l-1 mg--r-1" }, [
                _vm._v('"' + _vm._s(_vm.inputTxtValue) + '"'),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt2"))
                ),
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("damageMobilier.search.containerEmptyTxt3"))
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }